module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "news-link f-cb",
    attrs: {
      "href": _vm.path
    }
  }, [(_vm.showImg) ? _c('div', {
    staticClass: "col-l bg-d f-fl"
  }, [_c('div', {
    staticClass: "bg-c",
    style: ({
      backgroundImage: 'url(' + _vm.showImg + ')'
    })
  }), _vm._v(" "), _c('i', {
    class: ['icon', 'icon-' + _vm.item.type]
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-m"
  }, [_c('div', {
    staticClass: "title f-toe2"
  }, [_vm._v(_vm._s(_vm.item.listTitle || _vm.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "info-l"
  }, [(_vm.item.date) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("dataISO")(_vm.item.date)))]) : _vm._e(), _vm._v(" "), (_vm.showJoin) ? _c('span', {
    staticClass: "join-count"
  }, [_vm._v("参与 " + _vm._s(_vm.item.join_count))]) : _vm._e(), _vm._v("\n\t\t\t \n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "info-r"
  }, [(_vm.showTag) ? _c('span', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.item.tags))]) : _vm._e(), _vm._v(" "), (_vm.item.comments != '0' && _vm.item.comments) ? _c('span', {
    staticClass: "comment-count"
  }, [_vm._v(_vm._s(_vm.item.comments))]) : _vm._e(), _vm._v("\n\t\t\t \n\t\t")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d3d08e7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news_stream/news-normal.vue
// module id = 854
// module chunks = 2